import { usePdfCaptureStore } from "@plugins/authoring-copilot/pdf-capture.store.ts";
import type { PdfCaptureOpenParams } from "@plugins/authoring-copilot/pdf-capture.store.ts";

export function usePdfCaptureOverlay(): { open: (params: PdfCaptureOpenParams) => void } {
  const store = usePdfCaptureStore();
  return { open: store.open };
}
